<div class="loader-container">
    <app-loader
        [remainingAmount]="remainingAmount"
        [color]="color"
        [colorFill]="colorFill"
        [animate]="animate"
        [showNumber]="true"
        [number]="remainingTimeInSeconds"
    ></app-loader>
</div>
